import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export const OwnerPasswordCard = () => {
  const { setUser } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "", code: "" });
  const [ch, setCh] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const wrap = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); } };

  const start = () => wrap(async () => {
    if (f.next.length < 14) throw new Error("New password must be at least 14 characters");
    if (f.next !== f.confirm) throw new Error("New passwords don't match");
    const { data } = await api.post("/admin/password/start", { current_password: f.current });
    setCh(data); toast.success(`Code sent to ${data.email_hint}`);
  });
  const finish = () => wrap(async () => {
    const { data } = await api.post("/admin/password", { challenge_id: ch.challenge_id, code: f.code, new_password: f.next });
    setUser(data.user); setCh(null); setF({ current: "", next: "", confirm: "", code: "" });
    toast.success("Owner password changed");
  });

  return (
    <div className="lux-card p-6 mt-6" data-testid="owner-password-card">
      <p className="eyebrow"><KeyRound className="w-3.5 h-3.5 mr-1.5" />Owner password</p>
      <p className="text-xs text-slate-500 mt-2">At least 14 characters. We'll email you a code to confirm.</p>
      {!ch ? (
        <div className="mt-4 space-y-3">
          <input data-testid="owner-pw-current" type="password" placeholder="Current password" value={f.current} onChange={set("current")} className="lux-input" autoComplete="current-password" />
          <input data-testid="owner-pw-new" type="password" placeholder="New password (14+ characters)" value={f.next} onChange={set("next")} className="lux-input" autoComplete="new-password" />
          <input data-testid="owner-pw-confirm" type="password" placeholder="Repeat new password" value={f.confirm} onChange={set("confirm")} className="lux-input" autoComplete="new-password" />
          <button data-testid="owner-pw-start-btn" disabled={busy || !f.current} onClick={start} className="btn-gold w-full py-2.5 text-sm">{busy ? "Sending…" : "Email me a code"}</button>
        </div>
      ) : (
        <div className="mt-4 space-y-3">
          <input data-testid="owner-pw-code" inputMode="numeric" maxLength={6} placeholder="6-digit code" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.replace(/\D/g, "") })} className="lux-input font-mono-lux tracking-[0.4em] text-center" />
          <button data-testid="owner-pw-confirm-btn" disabled={busy || f.code.length !== 6} onClick={finish} className="btn-gold w-full py-2.5 text-sm">{busy ? "Saving…" : "Change password"}</button>
          <button data-testid="owner-pw-cancel-btn" onClick={() => setCh(null)} className="text-xs text-slate-400 hover:text-slate-200">Cancel</button>
        </div>
      )}
    </div>
  );
};
